export const REFUND_POLICY_URL = "https://yoast.com/refund-policy/";
export const TERMS_OF_SERVICE_URL = "https://yoast.com/terms-of-service/";
export const SWITCH_BILLING_FAQ_URL = "https://yoast.com/help/subscription-modifications-faq/";
export const REDUCED_MOTION_MEDIA_QUERY = "(prefers-reduced-motion: reduce)";
